export enum Label {
  Tournament = "Tournament",
}
